import { render, staticRenderFns } from "./updateImg.vue?vue&type=template&id=1b09bb6f&scoped=true&"
import script from "./updateImg.vue?vue&type=script&lang=js&"
export * from "./updateImg.vue?vue&type=script&lang=js&"
import style0 from "./updateImg.vue?vue&type=style&index=0&id=1b09bb6f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b09bb6f",
  null
  
)

export default component.exports